export default __webpack_public_path__ + "b6c4d0f47de28c3d618ea365ef55011e.svg";